<script lang="ts">
    import EmptyStateMessage from "$/pages/_templates/EmptyStateMessage.svelte";
    import LoadingMessage from "$/pages/_templates/LoadingMessage.svelte";
    import GridView from "./GridView.svelte";
    import ListView from "./ListView.svelte";
    import BoardView from "./BoardView.svelte";
    import LoadingBar from "$/components/LoadingBar/LoadingBar.svelte";
    import { TopicViewStore, TopicViewTypes } from "$/stores/TopicViewStore";
    import { ActiveTopicStore, ActiveTopic, TopicAccessLevel } from "$/stores/extension/ActiveTopicStore";
    import { StoreStatus } from "$/models/StoreStatus";

    export let snippets: any[] = [];
    export let userTopicRole: number = TopicAccessLevel.NO_ACCESS;
    export let selectedTagNames: string[] = [];
    export let user: any = {};
    export let topic: any = {};
    export let hideReactions: boolean = false;

    $: props = {
        userTopicRole,
        selectedTagNames,
        user,
        hideReactions,
    };

    $: isTopicNull = $ActiveTopic === null;
    $: showLoadingBar =  $ActiveTopicStore.state.status === StoreStatus.UPDATING;
    $: isSnippetsEmpty = $ActiveTopic?.snippets?.length === 0 && $ActiveTopic !== null;
    $: isNoSelectedTags = props.selectedTagNames.length === 0;
    $: selectedView = $TopicViewStore
        ? TopicViewStore.selectedViewByTopicId($ActiveTopic?.id)
        : TopicViewTypes.BOARD;
</script>

<LoadingBar show={showLoadingBar} />

{#if isTopicNull || (isSnippetsEmpty && !isTopicNull)}
    <div class="snippets_wrapper">
        {#if isTopicNull}
            <LoadingMessage/>
        {:else if isSnippetsEmpty && !isTopicNull}
            {#if isNoSelectedTags}
                <EmptyStateMessage type="snippet" />
            {:else}
                <EmptyStateMessage type="snippet_filter" />
            {/if}
        {/if}
    </div>
{:else if selectedView === TopicViewTypes.BOARD}
    <BoardView {props} />
{:else if selectedView === TopicViewTypes.GRID}
    <GridView {props} />
{:else if selectedView === TopicViewTypes.LIST}
    <!-- <ListView {props} /> -->
{/if}

<style>
    .snippets_wrapper {
        @apply flex flex-grow flex-col items-center overflow-x-hidden px-1 md:flex-row md:flex-nowrap md:items-start md:overflow-x-auto md:overflow-y-clip md:px-0;
    }
</style>
